import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import AuthProvider from './components/auth/AuthProvider';
import AuthGuard from './components/layout/AuthGuard';
import AdminGuard from './components/layout/AdminGuard';
import SubscriberGuard from './components/layout/SubscriberGuard';
import Topbar from './components/layout/Topbar';
import Footer from './components/layout/Footer';
import Landing from './routes/Landing';
import Pricing from './routes/Pricing';
import SignIn from './routes/SignIn';
import Welcome from './routes/Welcome';
import Account from './routes/Account';
import Subscribe from './routes/Subscribe';
import BillingReturn from './routes/BillingReturn';
import Inventory from './routes/Inventory';
import PartDetail from './routes/PartDetail';
import Quote from './routes/Quote';
import Vehicles from './routes/Vehicles';
import Orders from './routes/Orders';
import Heritage from './routes/Heritage';
import NotFound from './routes/NotFound';
import AdminDashboard from './routes/admin/AdminDashboard';
import InventoryManager from './routes/admin/InventoryManager';
import PartEditor from './routes/admin/PartEditor';
import BulkImport from './routes/admin/BulkImport';
import Subscribers from './routes/admin/Subscribers';
import Agents from './routes/admin/Agents';

const QuotePdf = lazy(() => import('./routes/QuotePdf'));

function RouteFallback() {
  return (
    <div className="app">
      <div className="main" style={{ display: 'grid', placeItems: 'center', minHeight: '60vh' }}>
        <div style={{ color: 'var(--text-muted)', fontFamily: 'var(--mono)', letterSpacing: '0.18em', fontSize: 11 }}>
          ◊ ◊ ◊
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Topbar />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/welcome" element={<AuthGuard><Welcome /></AuthGuard>} />
          <Route path="/subscribe" element={<AuthGuard><Subscribe /></AuthGuard>} />
          <Route path="/billing/return" element={<AuthGuard><BillingReturn /></AuthGuard>} />
          <Route path="/account" element={<AuthGuard><Account /></AuthGuard>} />
          <Route path="/inventory" element={<SubscriberGuard><Inventory /></SubscriberGuard>} />
          <Route path="/inventory/:partId" element={<SubscriberGuard><PartDetail /></SubscriberGuard>} />
          <Route path="/quote" element={<SubscriberGuard><Quote /></SubscriberGuard>} />
          <Route path="/quote/pdf" element={<SubscriberGuard><QuotePdf /></SubscriberGuard>} />
          <Route path="/vehicles" element={<SubscriberGuard><Vehicles /></SubscriberGuard>} />
          <Route path="/orders" element={<SubscriberGuard><Orders /></SubscriberGuard>} />
          <Route path="/heritage" element={<AuthGuard><Heritage /></AuthGuard>} />
          <Route path="/admin" element={<AdminGuard><AdminDashboard /></AdminGuard>} />
          <Route path="/admin/inventory" element={<AdminGuard><InventoryManager /></AdminGuard>} />
          <Route path="/admin/inventory/new" element={<AdminGuard><PartEditor /></AdminGuard>} />
          <Route path="/admin/inventory/import" element={<AdminGuard><BulkImport /></AdminGuard>} />
          <Route path="/admin/inventory/:id/edit" element={<AdminGuard><PartEditor /></AdminGuard>} />
          <Route path="/admin/subscribers" element={<AdminGuard><Subscribers /></AdminGuard>} />
          <Route path="/admin/agents" element={<AdminGuard><Agents /></AdminGuard>} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
      <Footer />
    </AuthProvider>
  );
}
